/* eslint-disable */
import BASE from '../../../../vue.config.js'
const $ = require('jquery')
import 'prismjs'
import 'prismjs/themes/prism.css'
import Vue from 'vue/dist/vue.js'

export default {
 data() {
	 	return{
	 	 	news:[],
	 	 	newsColumns:{
	 	 		col1:[],
	 	 		col2:[],
	 	 		col3:[]
	 	 	},
	 	 	colTurns:1
		}
	},
	methods: {
	 	ObtenerComunicados(){
		  fetch(`${BASE.baseUrl}api/ListadoAvisos/1/1`, {
	    method: 'GET',
	    headers: {
  		   'Authorization': sessionStorage.getItem('token'),
  		   'pagina':' planteles',
  		   'paginaOrigen':'litadoPlanteles'
    		}
	  	})
		  .then(rs => rs.json())
		  .catch(error => console.log('error:', error))
		  .then(rs => {
		    if(rs.status == 200){
		      rs.result.avisos.forEach((item, indx) => {
		      	if (item.imagen == '') {
		      		item.imagen = 'Img/Avisos/1/b8734f53-c54f-48c8-bfbf-d888e7814968.jpg'
		      	}
		        item.imagen = BASE.baseUrl + item.imagen;
		        item.backGroundImage = `background-image: url(${item.imagen})`
		        item.shortDate = item.fecha.slice(0, -8);
		        this.news.push(item);
		      });
		      this.news.reverse()
		      // console.log(JSON.stringify(this.news));
		      this.createNewsColumns();
		      console.log(this.newsColumns)
		    }
		  });
		},
		createNewsColumns(){
			this.news.forEach(element=>{
				if(this.colTurns==1){
			  	this.newsColumns.col1.push(element)
			    this.colTurns++;
			  }else if(this.colTurns==2){
			  	this.newsColumns.col2.push(element)
			    this.colTurns++;
			  }else if(this.colTurns==3){
			  	this.newsColumns.col3.push(element)
			    this.colTurns++;
			  }
			  if(this.colTurns > 3){this.colTurns = 1}
			})
		}
	},
	mounted(){
		this.ObtenerComunicados();
		// console.log(JSON.stringify(this.newsColumns));
	}
}
